<template>
  <!-- Manual logging, the same on the signup card and the contact panel: every
       entry becomes one contact_interactions row (POST /contacts/{id}/interactions).
       Emits log({ kind, outcome? }) — the parent opens its note prompt. -->
  <div ref="root" class="inline-flex items-center gap-1.5" @click.stop>
    <div class="relative inline-flex">
      <button @click="toggle('note')" :disabled="disabled" :class="buttonClass" title="Add a note / log an outside text or email">
        <DocumentTextIcon class="h-4 w-4" />
      </button>
      <div v-if="open === 'note'" :class="menuClass">
        <button v-for="o in NOTE_OPTIONS" :key="o.kind" @click="pick(o.kind)" :class="itemClass">{{ o.label }}</button>
      </div>
    </div>
    <div class="relative inline-flex">
      <button @click="toggle('call')" :disabled="disabled" :class="buttonClass" title="Log a call">
        <PhoneIcon class="h-4 w-4" />
      </button>
      <div v-if="open === 'call'" :class="menuClass">
        <button @click="pick('call', 'spoke')" :class="itemClass">Spoke</button>
        <button @click="pick('call', 'voicemail')" :class="itemClass">Left Voicemail</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { DocumentTextIcon, PhoneIcon } from '@heroicons/vue/24/outline'

defineProps({
  disabled:    { type: Boolean, default: false },
  buttonClass: { type: String, default: 'quick-log-btn' },
})
const emit = defineEmits(['log'])

const NOTE_OPTIONS = [
  { kind: 'note',  label: 'Add Note' },
  { kind: 'text',  label: 'Log External Text' },
  { kind: 'email', label: 'Log External Email' },
]
const menuClass = 'absolute right-0 bottom-full mb-1 z-20 min-w-[160px] bg-surface dark:bg-surface-dark border border-stroke-subtle dark:border-stroke-dark rounded-lg shadow-lg overflow-hidden'
const itemClass = 'block w-full text-left px-3 py-2 text-sm text-fg-secondary dark:text-fg-secondary-dark hover:bg-surface-muted dark:hover:bg-surface-hover-dark whitespace-nowrap'

const open = ref(null)
const root = ref(null)
const toggle = (which) => { open.value = open.value === which ? null : which }
const pick = (kind, outcome) => {
  open.value = null
  emit('log', outcome ? { kind, outcome } : { kind })
}

const onOutside = (e) => { if (root.value && !root.value.contains(e.target)) open.value = null }
onMounted(() => document.addEventListener('click', onOutside))
onUnmounted(() => document.removeEventListener('click', onOutside))
</script>
